import { SalesArticleSummary } from '@app/api';

export class Collection {
  id: string;
  brandId: string;
  brandName: string;
  icon: string;
  title: string;
  subTitle: string;
  banner: string;
  items: CollectionSection[];
  salesArticles?: SalesArticleSummary[];
  salesArticleIds: string[];
}

export class CollectionSection {
  id: string;
  collectionImages: {
    image: string;
    width: CollectionBannerWidth;
    fullHeight: boolean;
    items?: ImageItem[];
  }[];
}

export class ImageItem {
  left: string;
  top: string;
  salesArticle?: SalesArticleSummary;
  salesArticleId?: string;
}

export enum CollectionBannerWidth {
  '25%' = 'w-full md:w-1/4',
  '33%' = 'w-full md:w-1/3',
  '50%' = 'w-full md:w-1/2',
  '66%' = 'w-full md:w-2/3',
  '75%' = 'w-full md:w-3/4',
  '100%' = 'w-full md:w-full'
}
